/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvoiceRequest } from '../../models/invoice-request';

export interface ApiRequestInvoiceGetPreviewGet$Params {
  id?: string;
}

export function apiRequestInvoiceGetPreviewGet(http: HttpClient, rootUrl: string, params?: ApiRequestInvoiceGetPreviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceRequest>> {
  const rb = new RequestBuilder(rootUrl, apiRequestInvoiceGetPreviewGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvoiceRequest>;
    })
  );
}

apiRequestInvoiceGetPreviewGet.PATH = '/api/Request/Invoice/GetPreview';
